module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/cognito-sync-2014-06-30.paginators.json
// module id = 334
// module chunks = 0